import { useEventListener, Scope } from '../effects/EventListener'
import {
  OverlayTriggerVariant,
  OverlayTriggerVariantNS,
} from '../state/OverlayTrigger'

interface Config {
  value?: boolean
  off: (event: any) => any
  on: (event: any) => any
  trigger: OverlayTriggerVariant
  scope: Scope
}

export const triggerListeners = ({
  value,
  off,
  on,
  trigger,
  scope,
}: Config) => {
  switch (trigger) {
    case OverlayTriggerVariantNS.click:
      const handler = value ? off : on
      useEventListener({
        dependencies: [handler],
        event: 'click',
        scope,
        handler,
      })
      break
    case OverlayTriggerVariantNS.contextmenu:
      const ctxMenuHandler = value ? off : on
      useEventListener({
        dependencies: [ctxMenuHandler],
        event: 'contextmenu',
        scope,
        handler: ctxMenuHandler,
      })
      break
    case OverlayTriggerVariantNS.hover:
      useEventListener({ event: 'mouseleave', scope, handler: off })
      useEventListener({ event: 'mouseenter', scope, handler: on })
      break
  }
}
